// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.container {
  width: 100%; height: 100%;
  pointer-events: fill;
  background: rgba(0.1,0.1,0.1,0.3);
}

.loader-container {
  position: absolute;
  left: 50%;
  top: 50%;
  background: white;
  box-shadow: 0 0 10px #6c6c6c;
  border: 1px solid lightgray;
  padding: 10px;
  transform: translate(-50%, -50%);
}
.loader-spinner {
  display: flex;
  margin-left: auto;
  margin-right: auto;
}
.api-connection {
  bottom: 10px;
  position: absolute;
  left: 50%;
  transform: translate(-50%);
  background: #5a5a5aeb;
  padding: 5px 10px;
  border-radius: 5px;
  color: #f6f6f6;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 13px;
}
  `, "",{"version":3,"sources":["webpack://./src/app/components/base-components.ts"],"names":[],"mappings":";;AAEA;EACE,WAAW,EAAE,YAAY;EACzB,oBAAoB;EACpB,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,iBAAiB;EACjB,4BAA4B;EAC5B,2BAA2B;EAC3B,aAAa;EACb,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,0BAA0B;EAC1B,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;AACjB","sourcesContent":["\n\n.container {\n  width: 100%; height: 100%;\n  pointer-events: fill;\n  background: rgba(0.1,0.1,0.1,0.3);\n}\n\n.loader-container {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  background: white;\n  box-shadow: 0 0 10px #6c6c6c;\n  border: 1px solid lightgray;\n  padding: 10px;\n  transform: translate(-50%, -50%);\n}\n.loader-spinner {\n  display: flex;\n  margin-left: auto;\n  margin-right: auto;\n}\n.api-connection {\n  bottom: 10px;\n  position: absolute;\n  left: 50%;\n  transform: translate(-50%);\n  background: #5a5a5aeb;\n  padding: 5px 10px;\n  border-radius: 5px;\n  color: #f6f6f6;\n  text-transform: uppercase;\n  font-weight: bold;\n  font-size: 13px;\n}\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
